import { createFileRoute, redirect } from '@tanstack/react-router'

/** Compatibility redirect: seats now live on the unified Members & seats page. */
export const Route = createFileRoute('/_ws/w/$workspaceId/members/seats')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/w/$workspaceId/members',
      params: { workspaceId: params.workspaceId },
    })
  },
})
